
import {defineComponent, ref, watch} from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {Actions} from "@/store/enums/StoreEnums";
import {useStore} from "vuex";

export default defineComponent({
  name: "edit-transaction-modal",
  props: ["transaction", "reloadData"],
  components: {},
  setup(props) {
    const store = useStore();
    const formRef = ref<null | HTMLFormElement>(null);
    const editTransactionModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      quantity: props.transaction && props.transaction.quantity
    });

    watch(() => props.transaction, first => {
      formData.value = first
    });

    const rules = ref({
      title: [
        {
          required: true,
          message: "Title is required",
          trigger: "change",
        },
      ],
      type: [
        {
          required: true,
          message: "Type is required",
          trigger: "change",
        },
      ]
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;

          setTimeout(() => {
            loading.value = false;

            store
                .dispatch(Actions.TRANSACTION_UPDATE, formData.value)
                .then(() => {
                  loading.value = false;
                  props.reloadData()
                  hideModal(editTransactionModalRef.value);
                })
                .catch(() => {
                  loading.value = false;

                  Swal.fire({
                    text: store.getters.getErrors[0],
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Try again!",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-danger",
                    },
                  });
                });
          }, 2000);
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      editTransactionModalRef,
    };
  },
});
